module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-0e2910663135ece5c0a1abab4a54adb1.svg";